import userTypeService from "@/services/userType";
import router from "../../router/index";

const getDefaultState = () => {
  return {
    userTypeList: [],
    parentsList: [],
    allUsersTypes: [],
    userTypesBySitesIds : [],
    pre_registration_user_types: null,
    loading: false,
    modalState: false,
    changeRegMethodMsg: null,
    allowNotSelectHost: null,
    hostUserTypesExist: null,
  };
};

export const state = getDefaultState();

export const actions = {
  fetchUserTypeList({ commit }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      userTypeService
        .getUserTypesWithChildren(params)
        .then((data) => {
          resolve(data);
          commit("setUserTypeList", data.data);
          commit("modal/setModalState", false, { root: true });
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
        });
    });
  },
  fetchUserTypeDuplication({ commit }, params) {
    commit("setLoading", false);
    return new Promise((resolve, reject) => {
      userTypeService
        .getUserTypesDuplication(params)
        .then((data) => {
            resolve(data);
        })
        .catch((err) => {
            reject(err);
          this._vm.$toast.error(err.data.data.message ? err.data.data.message : err.data.message);
        });
    });
  },
  fetchAllUserType(params) {
    // commit("setLoading", true);
    return new Promise((resolve, reject) => {
      userTypeService
        .getAllUsersTypes(params)
        .then((data) => {
          resolve(data);
          // console.log('data', data.data);
          // commit("setAllUsersTypes", data.data);
          // commit("modal/setModalState", false, { root: true });
          // commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          // commit("setLoading", false);
        });
    });
  },
  fetchUserTypesWithHierarchy({ commit }) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      userTypeService
        .getUserTypesWithHierarchy()
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
        });
    });
  },
  fetchAllPreRegistrationByAdminUserTypes({ commit }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      userTypeService
        .getAllPreRegistrationByAdminUserTypes(params)
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchAllPreRegistrationByAdminUserTypesAndPermittedNormalAreas({ commit }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      userTypeService
        .getAllPreRegistrationByAdminUserTypesAndPermittedNormalAreas(params)
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchAllParentsUserType() {
    return new Promise((resolve, reject) => {
      userTypeService
        .getAllParentsUsersTypes()
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchParentsList({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit("setLoading", true);
      userTypeService
        .getTypesParent(payload)
        .then((data) => {
          resolve(data);
          commit("setParentsList", data.data);
          commit("setLoading", false);
          dispatch("grid/resetSelectedRows", null, { root: true });
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
        });
    });
  },
  // fetchAllParentsUserType() {
  //   return new Promise((resolve, reject) => {
  //     userTypeService
  //       .getAllParentsUsersTypes()
  //       .then((data) => {
  //         resolve(data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
  createUserType({ commit }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      userTypeService
        .createUserType(payload)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success(data.message)
          router.push("/user-types");
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  deleteUserType({ commit, dispatch }, id) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      userTypeService
        .deleteUserType(id)
        .then((data) => {
          resolve(data);

          // data.data.length
          //   &&
          //   data.data.map(item => {
          //     item == 1
          //       ?
          //       this._vm.$toast.success("User type deleted")
          //       :
          //       this._vm.$toast.error("User type can not be deleted");
          //   })
          this._vm.$toast.success(data.message);
          commit("setLoading", false);
          dispatch("fetchUserTypeList");
          dispatch("fetchAllUserType");
          commit("modal/setModalState", true, { root: true });
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          commit("modal/setModalState", false, { root: true });
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  updateUserType({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve) => {
      userTypeService
        .updateUserType(params)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success(data.message);
          commit("setLoading", false);
          dispatch("fetchUserTypeList");
          dispatch("fetchAllUserType");
          commit("setModalState", true);
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("setModalState", false);
          commit("modal/setModalState", false, { root: true });
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  moveUserType({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve) => {
      userTypeService
        .moveUserType(params)
        .then((data) => {
          resolve(data);
          // data.data.length
          //   &&
          //   data.data.map(item => {
          //     item == 1
          //       ?
          //       this._vm.$toast.success("User type moved")
          //       :
          //       this._vm.$toast.error("User type can not be moved");
          //   })
          this._vm.$toast.success(data.message);
          commit("setModalState", true);
          commit("setLoading", false);
          dispatch("fetchUserTypeList");
          dispatch("fetchAllUserType");
          commit("modal/setModalState", true, { root: true });
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("setModalState", false);
          commit("modal/setModalState", false, { root: true });
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchRegistrationTypes({ commit }, id) {
    const pre_reg_url = process.env.VUE_APP_PRE_REGISTRATION_URL;
    return new Promise((resolve, reject) => {
      userTypeService
        .getRegistrationTypes(id)
        .then((data) => {
          resolve(data);
          commit("setPreRegistrationTypes", data.data.data);
        })

        .catch((err) => {
          reject(err);
          router.push({ path: '/404', hash: `#${pre_reg_url}` })
        });
    });
  },

  getHostSettings({ commit }, payload) {
    return new Promise((resolve, reject) => {
      userTypeService
        .getHostSettings(payload)
        .then((data) => {
          resolve(data);
          console.log('hostsett', data);
          commit("setAllowNotSelectHost", data.data.data.allowNotSelectHost);
          commit("setHostUserTypesExist", data.data.data.hostUserTypesExist);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchAllHosts({ commit }, payload) {
    return new Promise((resolve, reject) => {
      userTypeService
        .getHostOptions(payload)
        .then((data) => {
          resolve(data);
          // console.log('fetchAllHosts', data);
          // commit("setAllowNotSelectHost", data.data.data.allowNotSelectHost);
        })
        .catch((err) => {
          reject(err);
          commit("setAllowNotSelectHost", null);

        });
    });
  },
  
  resetState({ commit }) {
    commit("setModalState", false);
    commit("setLoading", false);
  },

  resetChangeRegMethodMsg({ commit }) {
    console.log('reset msg');
    commit("setChangeRegMethodMsg", null);
  },

  setAllowNotSelectHost({ commit }, payload) {
    commit("setAllowNotSelectHost", payload);
  },

  setHostUserTypesExist({ commit }, payload) {
    commit("setHostUserTypesExist", payload);
  },

  checkChangeRegMethod({ commit }, id) {
    return new Promise((resolve, reject) => {
      userTypeService
        .getCheckChangeRegMethod(id)
        .then((data) => {
          resolve(data);
          if (!data.data.data.status) commit("setChangeRegMethodMsg", data.data.data.message);
          else commit("setChangeRegMethodMsg", null);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  checkChangeRegAllowed({ commit }, id) {
    return new Promise((resolve, reject) => {
      userTypeService
        .getCheckChangeRegAllowed(id)
        .then((data) => {
          resolve(data);
          console.log('data', data);
          if (!data.data.status) {
            commit("setChangeRegMethodMsg", data.data.message);
          }
          else {
            commit("setChangeRegMethodMsg", null);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  async fetchAvailableHosts({ commit }, params) {
    return new Promise((resolve, reject) => {
      userTypeService.getAvailableHosts(params)
        .then(data => {
          resolve(data)
          commit('setAvailableHosts', data.data)
        }).catch((err) => {
          reject(err);
        });
    })
  },
  fetchUserTypesBySitesIds({ commit }, params) {
    return new Promise((resolve , reject ) => {
      userTypeService
        .getUserTypesBySitesIds(params)
        .then((data) => {
          commit("setUserTypesBySitesIds", data.data);
          resolve(data);
        })
        .catch((err) => {
          console.log('err',err);
          reject(err);
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
};

export const mutations = {
  resetUserTypesState(state) {
    // Merge rather than replace so we don't lose observers
    Object.assign(state, getDefaultState());
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setUserTypeList(state, payload) {
    state.userTypeList = payload;
  },
  setParentsList(state, payload) {
    state.parentsList = payload;
  },
  setAllUsersTypes(state, payload) {
    state.allUsersTypes = payload;
  },
  setModalState(state, payload) {
    state.modalState = payload;
  },
  setPreRegistrationTypes(state, payload) {
    state.pre_registration_user_types = payload;
  },
  setChangeRegMethodMsg(state, payload) {
    state.changeRegMethodMsg = payload;
  },
  setAllowNotSelectHost(state, payload) {
    state.allowNotSelectHost = payload;
  },
  setHostUserTypesExist(state, payload) {
    state.hostUserTypesExist = payload;
  },
  setAvailableHosts(state, payload) {
    state.hostOptions = payload
  },
  setUserTypesBySitesIds(state, payload) {
    state.userTypesBySitesIds = payload;
  },
};

export const getters = {
  getLoading(state) {
    return state.loading;
  },
  // getJourneyFlowId(state) {
  //   return state.pre_registration_user_types?.user_types?.[0]?.pivot?.journey_flow_id;
  // },
  getModalState(state) {
    return state.modalState;
  },
  getUserTypeList(state) {
    return state.userTypeList;
  },
  getParentsList(state) {
    return state.parentsList;
  },
  getAllUsersTypes(state) {
    return state.allUsersTypes;
  },
  getPreRegistrationTypes(state) {
    return state.pre_registration_user_types?.user_types;
  },
  getPreRegistrationData(state) {
    return state.pre_registration_user_types;
  },
  getPreRegAreaDetails(state) {
    return state.pre_registration_user_types?.area;
  },
  getPreRegEntityDetails(state) {
    return state.pre_registration_user_types?.entity;
  },
  getPreRegTimeZoneDetails(state) {
    return state.pre_registration_user_types?.timeZone;
  },
  getJourneyId(state) {
    return state.pre_registration_user_types?.journeyId;
  },
  getTouchModeStatus(state) {
    return state.pre_registration_user_types?.touchModeStatus;
  },
  getNameSearchType(state) {
    return state.pre_registration_user_types?.nameSearchType;
  },
  getChangeRegMethodMsg(state) {
    return state.changeRegMethodMsg;
  },
  getAllowNotSelectHost(state) {
    return state.allowNotSelectHost;
  },
  getHostUserTypesExist(state) {
    return state.hostUserTypesExist;
  },
  getAvailableHosts(state) {
    return state.hostOptions;
  },
  getUserTypesBySitesIds(state) {
    return state.userTypesBySitesIds;
  },
};
